import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "map", "dealer", "filter" ];

  initialize() {
    this.clickPath = this.clickPath.bind(this)
  }

  connect() {
    for (let element of this.mapTargets) {
      for (let path of element.querySelectorAll("path")) {
        path.addEventListener("click", this.clickPath);
      }
    }
  }

  disconnect() {
    for (let element of this.mapTargets) {
      for (let path of element.querySelectorAll("path")) {
        path.removeEventListener("click", this.clickPath);
      }
    }
  }

  clickPath(e) {
    const elem = e.target;
    let titleParent = elem;
    let id = elem.id.replace(/[0-9]/g, '');
    let zubZone = parseInt(elem.id.replace(/[a-zA-Z]/g, '')) || 0;
    if (id.length === 0) {
        id = elem.parentElement.id;
        titleParent = elem.parentElement;
    }

    const title = titleParent.querySelectorAll("title");
    if (title.length === 1) {
      for (let filter of this.filterTargets) {
        filter.innerHTML = title[0].innerHTML;
      }
    }

    this.filterTarget.scrollIntoView({block: "start", behavior: "smooth"});
    this.updateList(id, zubZone);
  }

  mobileFilter(e) {
    e.preventDefault();
    if (e.target.value !== "0") {
      this.updateList(e.target.value, 0);
    } else {
      this.showAll();
    }
  }

  updateList(zoneId, subZone) {
    for (let dealer of this.dealerTargets) {
      const dealerSubZone = parseInt(dealer.dataset.subzone) ?? 0;
      const validSubZone = subZone === 0 || subZone === dealerSubZone;

      if (dealer.querySelectorAll("[data-zone='" + zoneId +"']").length && validSubZone) {
        dealer.classList.remove('hidden');
      } else {
        dealer.classList.add('hidden');
      }
    }
  }

  showAll() {
    for (let dealer of this.dealerTargets) {
      dealer.classList.remove('hidden');
    }
  }
}
